ThemeJS.Expandable_Card_Links = ( function ( $ ) {

  function init ( $items = null ) {
    $items = $items ?? $( 'section.expandable_card_links.wide-cards .card-link' );
    $items.each( function () {
      $(this).removeClass( 'initialized' );
      const height = $( 'div.height-set-inner', this ).outerHeight( true );
      $( 'div.height-set', this ).height( height );
      $( 'div.content-wrap', this ).css( 'padding-top', `${ height }px` );
      $(this).addClass( 'initialized' );
    });
  }

  $(window).on( 'breakpoint_changed', function () {
    init();
  });

  $( function () {
    init();
  });

  return {
      init
  };

})( jQuery );